import UserIcon from "@/assets/profile/7086FF_profile_users.svg";
import Button from "@/components/Common/Button";
import InputField from "@/components/Common/forms/InputField";
import PermissionSelect from "@/components/MultiAccount/PermissionSelect";
import ProfileSeparator from "@/pages/profile/ProfileSeparator";
import {inviteStateAtom} from "@/store/jotaiAtoms";
import type {TPermission} from "@/store/types";
import {useAtom} from "jotai";
import {type FC, type ReactNode} from "react";
import {useTranslation} from "react-i18next";

const InviteMember: FC<{
  logo: string;
  name: string;
  inviteMember(): void;
  showPermissionSelector?: boolean;
  fixPermission?: ReactNode;
}> = ({logo, name, inviteMember, showPermissionSelector = true, fixPermission}) => {
  const {t} = useTranslation(["multi_account", "common"]);
  const [invite, setInvite] = useAtom(inviteStateAtom);

  return (
    <>
      <div className="flex items-center gap-1.5">
        <img src={logo} className="border-soft-grey-500 size-10 shrink-0 rounded-full border" />
        <span className="font-medium">{name}</span>
      </div>
      <div className="flex flex-col gap-1.5">
        <span className="text-neutral-black text-xs">{t("invite_to", {name})}</span>
        <div className="flex flex-col items-center gap-3 md:flex-row md:gap-2">
          <InputField
            type="email"
            value={invite.email}
            onChange={value =>
              setInvite(state => {
                state.email = value;
              })
            }
            placeholder="sally@refluenced.com"
            className="h-10 px-3 py-2.5"
          />
          {showPermissionSelector ? (
            <PermissionSelect
              value={invite.permission}
              onChange={value =>
                setInvite(state => {
                  state.permission = value as TPermission;
                })
              }
            />
          ) : (
            fixPermission
          )}
          <Button
            onClick={inviteMember}
            buttonStyle="Gradient"
            isDisabled={!invite.email || !invite.permission}
            className="h-10 self-end px-5 py-4">
            {t("invite")}
          </Button>
        </div>
      </div>
      <ProfileSeparator text={t("multi_account:users_with_access")} icon={UserIcon} />
    </>
  );
};

export default InviteMember;
